module.exports = __webpack_public_path__ + "static/Grab-7e916dac2f942c8395e2852facd677a0.svg";